import React from "react";

export type HelpIconProps = {
  cx?: string;
};

export const HelpIcon: React.FC<HelpIconProps> = ({ cx = "" }) => {
  return (
    <svg
      width="22"
      height="22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx}
    >
      <path
        d="M11 4a6.986 6.986 0 0 0-4.953 2.05 7.01 7.01 0 0 0 0 9.902c2.73 2.73 7.176 2.73 9.906 0a7.01 7.01 0 0 0 0-9.901A6.986 6.986 0 0 0 11 4zm0 1.213c1.191 0 2.382.37 3.392 1.104L13.08 7.635a3.96 3.96 0 0 0-4.158 0L7.608 6.317A5.766 5.766 0 0 1 11 5.213zM6.314 7.611 7.632 8.93a3.98 3.98 0 0 0 0 4.15l-1.318 1.317a5.773 5.773 0 0 1 0-6.785zm9.372 0a5.773 5.773 0 0 1 0 6.785l-1.318-1.318a3.98 3.98 0 0 0 0-4.149l1.318-1.318zM11 8.26c.7 0 1.399.266 1.936.804a2.734 2.734 0 0 1 0 3.877 2.728 2.728 0 0 1-3.872 0 2.734 2.734 0 0 1 0-3.877A2.726 2.726 0 0 1 11 8.259zm-2.08 6.114a3.98 3.98 0 0 0 4.16 0l1.312 1.318a5.776 5.776 0 0 1-6.784 0l1.313-1.318z"
        fill="#111"
        fillOpacity=".8"
      />
    </svg>
  );
};
